import React from 'react';
import _ from 'lodash';
import { Field, reduxForm } from 'redux-form';
import { translate } from 'react-i18next';

import Button from '../common/Button';
import { maxLength, required, TextArea } from '../utils/form';

const max = 280;
const maxLengthValidator = maxLength(max);

const renderPlaceholder = (type, t) => {
  const cases = {
    PROJECT: () => {
      return (
        t('project.create.descrPlaceholderMemo') +
        _.sampleSize(
          _.sample([true, false])
            ? t('manageUpdates.userStatus.stillWorkingOnMessage', {
                returnObjects: true,
              })
            : t('manageUpdates.userStatus.noLongerWorkingOnMessage', {
                returnObjects: true,
              }),
          2
        ).join(' ')
      );
    },
    GOAL: () => {
      return t('goal.memo.descrPlaceholderMemo');
    },
  };

  return cases[type] ? cases[type]() : '';
};

const renderLabel = (type, t) => {
  const cases = {
    PROJECT: t('project.create.descrMemo'),
    GOAL: t('goal.memo.descrMemo'),
  };

  return cases[type] || '';
};

let Form = ({
  handleSubmit,
  onSubmit,
  submitting,
  error,
  okButtonText,
  t,
  invalid,
  type,
}) => (
  <form onSubmit={handleSubmit}>
    <Field
      component={TextArea}
      name="content"
      label={renderLabel(type, t)}
      validate={[required, maxLengthValidator]}
      max={max}
      required
      placeholder={renderPlaceholder(type, t)}
    />

    <div className="u-margin-top-huge u-text-center">
      <Button
        disbaled={invalid ? 1 : 0 || submitting ? 1 : 0}
        type="submit"
        className={`${invalid ? 'c-btn--disabled' : ''}`}
      >
        {submitting ? t('general.sending') : okButtonText}
      </Button>
    </div>

    {error && <p className="c-alert c-alert--danger u-margin-top">{error}</p>}
  </form>
);

Form = reduxForm()(translate()(Form));

export default Form;



// WEBPACK FOOTER //
// ./src/memos/Form.js